export type ProductAliasType = 'Manufacture' | 'Customer' | 'Consignment' | 'Placeholder';

export class ProductAlias {

  id: string;
  alias: string;
  tesscoPartNumber?: string;
  customerID?: string;
  description?: string;
  productName?: string;
  manufactureName?: string;
  type?: ProductAliasType;


  constructor(data: any = {}) {
    this.type = data.type || 'Manufacture';
    this.alias = data.alias;
    this.description = data.description;
    this.tesscoPartNumber = data.tesscoPartNumber;
  }

  static toString(product: Product) {
    return `[${product.sku}]-[${product.customerPartNumber}]-${product.name} (${product.manufacturerName})`;
  }
}

export class Product {
  sku: string;
  customerPartNumber: string;
  name: string;
  manufacturerName: string;
  isCableItem: boolean;
  isConsignedItem: boolean;
  minimumQuantity: number;
  manufacturerPartNumber: string;

  static toString(product: Product) {
    return `[${product.sku}]-[${product.manufacturerPartNumber}]-${product.name} (${product.manufacturerName})`;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/product-alias.ts